import axios from "axios";
import { HttpInterceptors } from "./http.interceptor";

class Http {
  client = axios;
  interceptor = new HttpInterceptors();

  constructor(
  ) {
    this.interceptor.request(this.client);
    this.interceptor.response(this.client);
  }
}

export const http = new Http();